import { Link } from "react-router-dom";
import "./loading.css";
const NotFound = () => {
  return (
    <>
      <div className="loading">
        <span className="loader"></span>
      </div>
    </>
  );
};

export default NotFound;
